import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3BlogPostsTitlesCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>
          Search engines love long, wordy, unique content. That's why blog posts perform well in search results. To get the most SEO value out of your blog posts they must contain a decent number of words.
        </p>
        <p>
          Try to accompany posts primarily of images, video or audio with your opinion or transcription of them.
        </p>
        <hr />
        <h2>How it's used</h2>
        <ul>
          <li>Search engines pick up keywords from blog post text</li>
          <li>Sometimes displayed as the paragraph text in search results when a good meta description isn't available</li>
          <li>Used in search engine algorithms</li>
        </ul>
        <hr />
        <h2>Best practice</h2>
        <ul>
          <li>Unique content: don't copy-and-paste from other sites</li>
          <li>Quoting from other sites (with attribution) is fine as long as the post is still primarily your own work</li>
          <li>Liberally but naturally include good keywords related to your business</li>
        </ul>
        <hr />
        <h2>Fix this yourself</h2>
        <p>
          Creating an editorial calendar for your blog is a good way to plan topics and guide your blogging towards more detailed textual posts.
        </p>
        <p>
          For the overall traffic benefit to your site, if a post is just images it may be more worthwhile to use a platform like Pinterest. Likewise for video, YouTube can extend your reach further. Soundcloud works well for audio.
        </p>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3BlogPostsTitlesCheck.js